<script lang="ts">
	import type { ConfigsEntity } from '$lib/api/restApi';

	export let configs: ConfigsEntity[];
</script>

<svelte:head>
	<script
		lang="js"
		id="hs-script-loader"
		async
		defer
		src="//js-eu1.hs-scripts.com/{configs[0].values.tracking_id}.js"
	></script>
</svelte:head>
